var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{attrs:{"title":"Все рекламодатели","error-text":"Список рекламодателей не загружен","settings-title":"Все рекламодатели","settings-loading":_vm.loading,"filters":_vm.filters,"table-options":_vm.table,"create-form":_vm.createForm,"is-hide-cols":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }